import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import io from 'socket.io-client'
import { iff, discard } from 'feathers-hooks-common'
import feathersVuex from 'feathers-vuex'

console.log(`Using API: ${process.env.VUE_APP_API_URL}`)
const apiSocket = io(process.env.VUE_APP_API_URL, { transports: ['websocket'], upgrade: false })

const apiErrorHandler = async context => {
  const { service, error } = context;
  //console.log('API error: ', error, context.hook && context.hook.path)

  if (error && error.code === 401) {
    console.log('API emit session expired...')
    apiClient.emit("authentication", { event: "session-expired" });
  } else if (error.name === 'Timeout' && service.FeathersVuexModel && service.FeathersVuexModel.store) {
    service.FeathersVuexModel.store.commit('app/appMessage', {
      text: `Your bot is currently applying changes...`,
      timeout: 5000
    })
  }
  return context;
};

const apiClient = feathers()
  .configure(socketio(apiSocket, {
    timeout: 15000
  }))
  .configure(auth({ storage: window.localStorage }))
  .hooks({
    before: {
      all: [
        iff(
          context => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp')
        )
      ]
    },
    error: {
      all: [apiErrorHandler]
    }
  })

// Setting up feathers-vuex
const { makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex } = feathersVuex(
  apiClient,
  {
    serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
    idField: 'id', // Must match the id field in your database table/collection
    whitelist: ['$regex', '$options', '$ilike'],
    paramsForServer: ['$eager', '$joinRelation']
  }
)

// Auth management
const authManagement = apiClient.service("authManagement");

export { apiClient, authManagement, makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex }